import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AvatarModule } from "@onsip/web/features/shared/components/avatar/avatar.module";
import { OnsipFormsModule } from "@onsip/web/features/shared/components/forms/onsip-forms.module";
import { SelectionListDeluxeModule } from "@onsip/web/features/shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { BhrPickerComponent } from "./bhrPicker/bhr-picker.component";
import { HolidayPickerComponent } from "./holidayPicker/holiday-picker.component";
import { PagePickerComponent } from "./pagePicker/page-picker.component";
import { PageRulePickerComponent } from "./pagePicker/pageRulePicker/page-rule-picker.component";
import { UrlPickerComponent } from "./pagePicker/pageRulePicker/urlPicker/url-picker.component";
import { RepPickerComponent } from "./repPicker/rep-picker.component";
import { TargetDisplayFormComponent } from "./targetDisplay/target-display-form.component";
import { VideoCheckboxComponent } from "./videoCheckbox/video-checkbox.component";
import { TopicWriteFormComponent } from "./topic-write-form.component";
import { CountryPickerComponent } from "./countryPicker/country-picker.component";
import { BHRTimeInputModule } from "@onsip/web/features/shared/components/pickers/bhrTime/bhr-time-input.module";

@NgModule({
  declarations: [
    TopicWriteFormComponent,
    VideoCheckboxComponent,
    TargetDisplayFormComponent,
    RepPickerComponent,
    PagePickerComponent,
    PageRulePickerComponent,
    UrlPickerComponent,
    HolidayPickerComponent,
    CountryPickerComponent,
    BhrPickerComponent
  ],
  exports: [TopicWriteFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MaterialModule,
    FormsModule,
    OnsipFormsModule,
    SelectionListDeluxeModule,
    AvatarModule,
    BHRTimeInputModule
  ]
})
export class TopicWriteFormModule {}
